import React, { useEffect, useState, useRef, useCallback } from "react";
import { useToast } from "@chakra-ui/react";
import { useSignalR } from "../../context";
import UpdateToast from "./UpdateToast";

const UpdateUI = ({ show, postponeSecs = 60 }) => {
  const toast = useToast();
  const toastIdRef = useRef();

  const showToast = useCallback(() => {
    toastIdRef.current = toast({
      title: "Update Pending...",
      status: "success",
      duration: null,
      isClosable: false,
      position: "bottom-right",
      variant: "subtle",
      render: (props) => (
        <UpdateToast onPostpone={onPostpone} title={props.title} />
      ),
    });

    function onPostpone() {
      toast.close(toastIdRef.current);
      setTimeout(() => {
        if (toastIdRef.current) {
          showToast();
        }
      }, postponeSecs * 1000);
    }
  }, [postponeSecs, toast]);
  useEffect(() => {
    if (show) {
      showToast();
    }
  }, [show, showToast]);
  return null;
};

const UpdateListener = ({ appName }) => {
  const { connection, isLoggedIn } = useSignalR();
  const [showUpdate, setShowUpdate] = useState(false);

  const onUpdate = useCallback(
    (data) => {
      const jsonData = JSON.parse(data);
      if (jsonData.application === appName) {
        setShowUpdate(true);
      }
    },
    [appName]
  );

  useEffect(() => {
    if (isLoggedIn) {
      connection.on("UpdateUI", onUpdate);
    }
    return () => {
      if (connection) {
        connection.off("UpdateUI", onUpdate);
      }
    };
  }, [connection, isLoggedIn, onUpdate]);

  return <UpdateUI show={showUpdate} />;
};

export default UpdateListener;
